import { useEffect } from "react";

/**
 * Escape closes the overlay. Bound only while open so the handler is not sitting on
 * the document for the whole session.
 *
 * Pass a falsy `isOpen` to opt out entirely — a mandatory gate that suppresses its
 * close button and backdrop dismiss has to suppress this escape hatch too, or the key
 * becomes the one way around a question the user must answer.
 *
 * @param {boolean} isOpen
 * @param {Function} [onClose]
 */
export const useEscapeKey = (isOpen, onClose) => {
  useEffect(() => {
    if (!isOpen || typeof onClose !== "function") return undefined;
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [isOpen, onClose]);
};

export default useEscapeKey;
